module.exports = __webpack_public_path__ + "img/ai.a6b653e3.svg";